<template>
  <div class="addr" :class="{ active: isChecked }">
    <div class="bd" @click="clkBody">
      <div class="info">
        <div class="info-left">
          <strong>{{ item.short_name }}</strong>
          <p class="address">{{ item.address }}</p>
          <p class="phone">{{ item.phone }}</p>
        </div>
        <div v-if="item.distance" class="info-right">
          <p>{{ item.distance | distance2km }}km</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  created() {},
  data() {
    return {
      title: '',
      isLocked: ''
    }
  },
  mounted() {},
  methods: {
    clkBody() {
      this.$emit('clkBody')
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    selectedId: null
  },
  computed: {
    isChecked() {
      return this.item.business_id === this.selectedId
    }
  },
  components: {}
}
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
@import '~assets/css/mixin.scss';

.addr {
  overflow: hidden;
  background: #fff;
  padding-left: rem(24px);
  padding-right: rem(24px);
  &.active {
    background: #f4f4f4;
  }
  .bd {
    overflow: hidden;
    padding-bottom: rem(30px);
    border-top: 1px solid #e8e8e8;
    .info {
      margin: rem(30px) 0 rem(30px) 0;
      font-weight: normal;
      color: #121212;
      font-size: rem(30px);
      .badge {
        font-size: rem(20px);
        color: #ff4b4b;
        height: rem(30px);
        line-height: rem(30px);
        display: inline-block;
        padding: 0 rem(13px);
        border: 1px solid;
        border-radius: rem(15px);
      }
      .info-left {
        float: left;
        width: 74%;
        .address {
          color: #121212;
          font-size: rem(28px);
          padding-top: rem(10px);
          padding-bottom: rem(20px);
        }
        .phone {
          font-size: rem(28px);
          color: #666;
        }
      }
      .info-right {
        float: right;
        width: 26%;
        text-align: right;
      }
      strong {
        font-size: rem(32px);
        color: #121212;
        font-weight: bold;
      }
    }
    .desc {
      font-size: rem(28px);
      color: #666;
      margin-right: rem(100px);
      line-height: 1.8em;
    }
  }
  .ft {
    height: rem(88px);
    padding: rem(24px) 0;
    padding-right: rem(24px);
    label {
      input[type='checkbox'] {
        display: none;
      }
      i {
        margin-right: rem(20px);
        display: inline-block;
        width: rem(36px);
        height: rem(36px);
        overflow: hidden;
        border: 1px solid #ddd;
        border-radius: 50%;
        color: transparent;
        font-size: rem(12px);
        text-align: center;
      }
      input:checked + i {
        border: none;
        background-image: linear-gradient(to right, #ff7d46, #ff4b4b);
        color: #fff;
      }
      span {
        font-size: rem(26px);
        color: #444;
      }
      i,
      span {
        line-height: rem(36px);
        vertical-align: middle;
      }
    }
    .action {
      float: right;
    }
    .btn {
      i {
        margin-left: rem(30px);
        margin-right: rem(10px);
        display: inline-block;
        width: rem(36px);
        height: rem(36px);
      }
      span {
        font-size: rem(26px);
        color: #444;
      }
      i,
      span {
        line-height: rem(36px);
        vertical-align: middle;
      }
      .icon-edit {
        background: url('~assets/images/order/btn_edit.png') no-repeat
          center/contain;
      }
      .icon-dele {
        background: url('~assets/images/order/icon_del_addr.png') no-repeat
          center/contain;
      }
    }
  }
}
</style>
